export const timelineParagraphClassName = "text-[13px] leading-snug tracking-[-0.01em] text-muted-foreground";
export const timelineActorClassName = "font-medium text-foreground";
export const timelineTimeClassName = "text-muted-foreground";
export const timelineLinkClassName =
  "inline-flex items-center gap-1 rounded-md text-[13px] text-foreground underline decoration-border underline-offset-2 hover:decoration-foreground";
